import QuestionCreatorLayout from '@/layouts/QuestionCreatorLayout.vue';

const questionCreatorRoutes = [
  {
    path: '/question-creator',
    component: QuestionCreatorLayout,
    meta: { 
      requiresAuth: true,
      role: '6'
    },
    children: [
      {
        path: '',
        redirect: 'questions'
      },
      {
        path: 'questions',
        name: 'CreatorQuestions',
        component: () => import('@/views/question/Questions.vue'),
        meta: { title: '题目管理' }
      }
    ]
  }
];

export default questionCreatorRoutes; 